(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vera-editorial-about"] && !Shopify.designMode) return;
  try {
    
  const veraEditorialVideoSelector = '.vera-editorial-card__inline-player';

  const pauseOtherEditorialVideos = (activeVideo) => {
    document.querySelectorAll(veraEditorialVideoSelector).forEach((video) => {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  };

  document.addEventListener(
    'play',
    (event) => {
      if (!event.target.matches(veraEditorialVideoSelector)) return;
      pauseOtherEditorialVideos(event.target);
    },
    true
  );

  const veraEditorialVideoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
      });
    },
    { threshold: 0.01 }
  );

  const observeEditorialVideos = (root) => {
    root.querySelectorAll(veraEditorialVideoSelector).forEach((video) => {
      if (video.dataset.veraViewportPause === 'true') return;
      video.dataset.veraViewportPause = 'true';
      veraEditorialVideoObserver.observe(video);
    });
  };

  observeEditorialVideos(document);

  document.addEventListener('shopify:section:load', (event) => {
    observeEditorialVideos(event.target);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    document.querySelectorAll(veraEditorialVideoSelector).forEach((video) => video.pause());
  });

  } catch(e) { console.error(e); }
})();
})();
